var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarLetterBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8337 9.9987C18.8337 13.1412 18.8337 14.7129 17.857 15.6887C16.8803 16.6645 15.3095 16.6654 12.167 16.6654H8.83366C5.69116 16.6654 4.11949 16.6654 3.14366 15.6887C2.16783 14.712 2.16699 13.1412 2.16699 9.9987C2.16699 6.8562 2.16699 5.28453 3.14366 4.3087C4.12033 3.33286 5.69116 3.33203 8.83366 3.33203H12.167C15.3095 3.33203 16.8812 3.33203 17.857 4.3087C18.402 4.85286 18.6428 5.58203 18.7487 6.66536",
    stroke: "#374655",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6.66406L13.7008 8.16406C12.1708 9.43906 11.405 10.0766 10.5 10.0766C9.95833 10.0766 9.4675 9.84823 8.83333 9.39323M5.5 6.66406L6.25 7.28906L7 7.91406",
    stroke: "#374655",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarLetterBroken);
export default __webpack_public_path__ + "static/media/solar_letter-broken.d25124ff6df0e1c9f337e754221198b6.svg";
export { ForwardRef as ReactComponent };